import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import PanelLastRegistrationPlate from '@adv-mt/mt-panel-last-registration-plate'

import {NEWS_DETAIL_LATEST_PLATES_WRAPPER_BASE_CLASS} from '../config.js'

const MIN_PLATE_LENGTH = 4

const adaptPlateNumber = ({plate}) => (plate.length < MIN_PLATE_LENGTH ? `**** ${plate}` : plate)

export const LatestPlatesWrapper = ({latestVehiclePlateEnabled}) => {
  const [latestPlates, setLatestPlates] = useState({items: []})
  const {domain} = useContext(Context)

  useMount(() => {
    const requestLatestPlates = async () => {
      const [latestPlatesError, latestPlatesResponse] = await domain.get('get_latest_plates_news_use_case').execute()

      if (latestPlatesError) {
        console.error('Error fetching latest plates:', latestPlatesError)
        return
      }

      const {lastPlate, date, platesByDate, stats} = latestPlatesResponse

      setLatestPlates({
        items: [
          {plateNumber: adaptPlateNumber({plate: lastPlate}), date},
          ...platesByDate.map(({plate, date}) => ({plateNumber: adaptPlateNumber({plate}), date}))
        ],
        stats
      })
    }

    requestLatestPlates()
  })

  if (!latestVehiclePlateEnabled) return null

  return (
    <div className={NEWS_DETAIL_LATEST_PLATES_WRAPPER_BASE_CLASS}>
      {Boolean(latestPlates.items.length) && (
        <PanelLastRegistrationPlate
          numEstimatedVehicles={latestPlates.stats.count}
          registrationPlates={latestPlates.items}
        />
      )}
    </div>
  )
}

LatestPlatesWrapper.propTypes = {
  latestVehiclePlateEnabled: PropTypes.bool.isRequired
}
